<template>
  <v-container fluid style='padding: 5px 0px 0px 10px !important;'>
    <p-user-welcome v-if="dialogUserWelcome" @close="dialogUserWelcome = false"></p-user-welcome>
    <p-register-complement v-if="dialogRegisterComplement" @next="nextRegisterComplement"></p-register-complement>
    <!-- O componente PTaskFather agora é utilizado com Vuex ao invés de utilizar "ref" porque ocorria um problema ao tentar gerar um relatório de tarefas filtradas. Foi alterado a estrutura para a geração de relatórios de tarefas. -->
    <p-task-father></p-task-father>
    <!-- // Armaze a versão do sistema do usuário para saber se tem que atualizar -->
    <!-- // Quando atualizar o system_version, também atualizar a versão na tabela "system" e a versão no arquivo webpack.base.conf.js(SWPrecacheWebpackPlugin) -->
    <v-dialog v-model="dialogReloadVersion" persistent width="500">
      <v-card>
        <v-card-title class="headline grey lighten-4" primary-title>
          <v-icon color="teal" large>new_releases</v-icon>
          <span class="headline"><strong>Existem atualizações!</strong></span>
          <v-progress-circular v-if="showProgressBar" style="right: 0; position: absolute; margin-right: 15px;" indeterminate></v-progress-circular>
          <v-btn v-else icon style="right: 0; position: absolute" slot="activator" fab @click="confirmReloadVersion">
            <v-icon color="black">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="text-column">
            <h2>Clique em "Confirmar" para atualizar o sistema!</h2>
            <h4>Caso tenha algum problema entre em contato com nosso suporte</h4>
            <br>
            <p class="ma-0"><strong>Telefone: </strong><strong style="color: blue;">(34) 99910-0135</strong> (Whatsapp)</p>
            <p><strong>Email: </strong><strong style="color: blue;">suporte.sistema@illissolucoes.com.br</strong></p>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="showProgressBar">
          <v-layout row wrap>
            <v-flex xs12>
              <p class="text-sm-center" style="margin-bottom: 0px;">Atualizando...</p>
            </v-flex> 
            <v-flex xs12>
              <v-progress-linear
                style="margin-top: 2px;"
                :value="progressBar"
                :active="true"
              ></v-progress-linear>
            </v-flex> 
          </v-layout>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="confirmReloadVersion">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Dialog para mostrar um video para o usuário quando tem alguma funcionalidade nova -->
    <p-dialog-beta></p-dialog-beta>
    <!-- Dialog para avisar ao usuário que a empresa foi excluída ou que ele foi removido dos participantes -->
    <p-dialog-warning></p-dialog-warning>
    <!-- Dialog para avisar ao usuário que a empresa foi excluída ou que ele foi removido dos participantes -->
    <p-change-log ref="changelog"></p-change-log>
    <p-loader></p-loader>
    <p-snackbar></p-snackbar>
    <p-snackbar-plan></p-snackbar-plan>
    <p-dialog-plan></p-dialog-plan>
    <p-snackbar-button></p-snackbar-button>
    <p-user-tasks v-if="userTasks"></p-user-tasks>
    <!-- <p-first-entrance @openParticipants="openCompanyUserDialog" v-if="firstEntrance"></p-first-entrance> -->
    <p-confirm-register v-if="openConfirmRegister" @close="openConfirmRegister = false"></p-confirm-register>
    <!-- // Quando tem atualizações mostra a tela pro usuário -->
    <p-upgrades-illis ref="PUpgradesIllis"></p-upgrades-illis>
    <!-- Inicio Componentes de ajuda ao usuário -->
    <p-free-training ref="PFreeTraining"></p-free-training>
    <!-- Fim Componentes de ajuda ao usuário -->
    <!-- Barra Lateral Desktop -->
    <v-navigation-drawer
      @mouseover.native="mini = false"
      @mouseleave.native="mini = true"
      v-model="drawer"
      :mini-variant.sync="mini"
      hide-overlay
      permanent
      fixed
      app
      v-if="!$vuetify.breakpoint.smAndDown"
      dark
      class="blue-grey darken-1"
      style="z-index: 6">
      <div class="navigattion-title" style="width: 100%; display:flex; justify-content: center;" @click="$router.push(`/home`)">
        <div class="app-company-title">
          <div class="avatar avatar-click" v-if="this.$auth.user().company && this.$auth.user().company.logo_path">
            <img :src="`${basePath}uploads/companies/${this.$auth.user().company.logo_path}`" alt="Logo">
          </div>
          <div class="text avatar-click" v-else>
            <i class="fas fa-building"></i>
          </div>
        </div>
        <v-list v-show="!mini">
          <v-btn v-if="checkIsFree()" :id="'in_info_plan_menu'" style="margin-left: 17px; margin-right: 0px'" color="yellow" outline flat @click.prevent="$refs.PInfoPlan.clickPlan()">
            <img src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px">&nbsp; Dados do Plano
          </v-btn>
          <v-btn v-else :id="'in_info_plan_menu'" style="margin-left: 25px; margin-right: 0px" outline flat @click.prevent="$refs.PInfoPlan.clickPlan()">Dados do Plano</v-btn>
          <p-info-plan ref="PInfoPlan"></p-info-plan>
        </v-list>
      </div>

      <v-list v-if="released" dense>
        <template v-for="(item, i) in items">
          <!-- <a class="plans-link" href="https://site.illis.com.br/planos" target="_blank">Ver Planos</a> -->
          <v-list-tile :id="'in_'+(i)+'_menu'" v-if="item.link" :key="i" :href="item.link" target="_blank">
            <v-list-tile-action>
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title slot="activator" v-text="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :id="'in_'+(item.route ? item.route : i)+'_menu'" v-else-if="item.title && checkPlanAccess(item.route, 'active')" :to="(item.route ? '/'+item.route : '')" @click="clickMenu(item.route ? '/'+item.route : '')"
              :key="i"
              :disabled="!checkPermission(item.route, 'view') || !checkPlanAccess(item.route, 'has')"
              @click.prevent="item.name === 'companyUser' ? openCompanyUserDialog() : callFunction(item.action)"
          >
            <v-list-tile-action>
              <v-badge right v-if="item.notify && checkPermission('connections', 'view')">
                <template v-slot:badge>
                  <span>{{connectionInvites}}</span>
                </template>
                <v-icon v-html="item.icon"></v-icon>
              </v-badge>
              <v-icon v-html="item.icon" v-else></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <!--<v-badge-->
                <!--color="green"-->
                <!--:content="connectionInvites"-->
                <!--:value="connectionInvites"-->
              <!--&gt;-->
               <!--<v-list-tile-title v-text="item.title"></v-list-tile-title>-->
              <!--</v-badge>-->
              <v-list-tile-title>
                <span>{{item.title}}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <div v-else-if="item.divider" :key="i">
            <v-divider v-if="!mini"></v-divider>
            <hr v-else class="hr-menu-divider">
          </div>
          <div v-else-if="item.header" :key="i">
            <v-subheader v-if="!mini" :key="item.header">{{ item.header }}</v-subheader>
            <div v-else class="div-menu-subheader pl-2">{{ item.header | formatAbbreviation(6) }}</div>
          </div>
        </template>
      </v-list>
      <v-divider></v-divider>
      <v-list v-if="checkIsFree()">
        <template>
          <v-btn :id="'in_upgrade_menu'" v-if="!mini" flat to="/upgrade" id="upgrade">
            <img src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px"> &nbsp; Fazer Upgrade
          </v-btn>
          <v-btn :id="'in_upgrade_menu'" v-else flat to="/upgrade" id="upgrade">
            <img src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px">
          </v-btn>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- Barra do Topo do Mobile -->
    <v-toolbar v-if="$vuetify.breakpoint.smAndDown" app dark :color="topBarColor" style="z-index: 5">
      <div class="mobile-toolbar-items">
        <div class="mobile-toolbar-item">
          <v-menu origin="center center" transition="scale-transition" bottom>
            <v-btn class="py-3" style="margin: 6px 0 0 0" slot="activator" :loading="loadCompany" @click="refreshCompany()" flat>
              <img height="42px" style="margin-left: 0; background: #fff; border-radius: 50%;" :src="`${basePath}uploads/companies/${$auth.user().company.logo_path}`" alt="Logo" v-if="$auth.user().company.logo_path">
              <div v-else>
                {{ $auth.user().company.id_text | formatAbbreviation(8) }}
              </div>
              <v-icon dark>arrow_drop_down</v-icon>
            </v-btn>
            <v-list two-line v-if="!loadCompany" class="companies_list">
              <v-subheader>{{ $auth.user().company.id_text }}</v-subheader>
              <v-list-tile @click="companyManage()">
                <v-list-tile-avatar>
                  <v-icon large>build</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Gerenciar Empresa</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-subheader>Outras Empresas</v-subheader>
              <template v-for="(item, index) in companies">
                <v-list-tile :key="index" avatar @click="changeCompany(item.id)" style="background: #fff">
                  <v-list-tile-avatar>
                    <div class="app-company-title">
                      <div class="avatar" v-if="item.logo_path">
                        <img :src="`${basePath}uploads/companies/${item.logo_path}`" alt="Logo">
                      </div>
                      <div class="text" v-else>
                        <i class="fas fa-building"></i>
                      </div>
                    </div>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.id_text"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="(item.company_plan.length > 0 ? 'Plano: ' + item.company_plan[0].plan.id_text : 'Plano: Grátis' )"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-menu>
        </div>

        <div class="mobile-toolbar-item">
          <v-btn to="/home" id="brand" flat>
            <v-icon dark>home</v-icon>
          </v-btn>
        </div>
        <div class="mobile-toolbar-item">
          <v-menu origin="center center" transition="scale-transition">
            <v-btn :id="'in_profile_btn'" flat slot="activator">
              <v-badge left bottom class='badge-company' :value="companyInvites > 0" color="#4b9ea9">
                <template v-slot:badge>
                  <span>{{companyInvites}}</span>
                </template>
                <div v-if="!this.$auth.user().photo_path">
                  <div class="user-avatar-menu">
                    <span class="user-avatar-item">{{ getFirstLetters(this.$auth.user().id_text) }}</span>
                    <v-icon dark>arrow_drop_down</v-icon>
                  </div>
                </div>
                <div v-else>
                  <img :src="`${basePath}uploads/users/${this.$auth.user().photo_path}`" height="42px" style="margin-right:0; border-radius: 50%;">
                  <v-icon dark>arrow_drop_down</v-icon>
                </div>
              </v-badge>
            </v-btn>
            <v-list style="width: 135px;">
              <v-list-tile :id="'in_companies_profile'" to="/companies">
                  <v-list-tile-title class="company-menu-title">
                    <span>Empresas</span>
                    <span v-if="companyInvites > 0" class="span-badge">{{companyInvites}}</span>
                  </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :id="'in_user_profile'" to="/user">
                <v-list-tile-title>Editar Perfil</v-list-tile-title>
              </v-list-tile>
              <v-list-tile :id="'in_logout_profile'" @click="logout()">
                <v-list-tile-title>Sair</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
    </v-toolbar>

    <!-- Barra do Topo do Desktop -->
    <v-toolbar v-else app dark :color="topBarColor" dense style="z-index: 5">
      <v-menu origin="center center" transition="scale-transition" bottom>
        <v-btn class="py-4" style="margin: 0;" slot="activator" :loading="loadCompany" @click="refreshCompany()" flat>
          <div>
            {{ $auth.user().company.id_text | formatAbbreviation(25) }}
          </div>
          <v-icon dark>arrow_drop_down</v-icon>
        </v-btn>
        <v-list two-line v-if="!loadCompany" class="companies_list">
          <v-subheader>{{ $auth.user().company.id_text }}</v-subheader>
          <v-list-tile @click="companyManage()">
            <v-list-tile-avatar>
              <v-icon large>build</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Gerenciar Empresa</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-subheader>Outras Empresas</v-subheader>
          <template v-for="(item, index) in companies">
            <v-list-tile :key="index" avatar @click="changeCompany(item.id)" style="background: #fff">
              <v-list-tile-avatar>
                <div class="app-company-title">
                  <div class="avatar" v-if="item.logo_path">
                    <img :src="`${basePath}uploads/companies/${item.logo_path}`" alt="Logo">
                  </div>
                  <div class="text" v-else>
                    <i class="fas fa-building"></i>
                  </div>
                </div>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.id_text"></v-list-tile-title>
                <v-list-tile-sub-title v-html="(item.company_plan.length > 0 ? 'Plano: ' + item.company_plan[0].plan.id_text : 'Plano: Grátis' )"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-menu>
      <!-- <v-btn to="/home" id="brand" flat>
        <v-icon large dark>home</v-icon>
      </v-btn> -->
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <div id="in_help_buttons" class="avatar_training_button" flat large v-on="on">
              <v-icon>help_outline</v-icon>
              <span>Precisa de Ajuda?</span>       
            </div>
          </template>
          <v-list>
            <v-list-tile id="in_purechat_help" @click="purechatClick()">
              <v-icon>contact_support</v-icon>&ensp;&ensp;
              <span>Chat</span>
            </v-list-tile>

            <v-list-tile id="in_youtube_help" :href="'https://www.youtube.com/channel/UChnglEU6grDpO2lHvrmyG0Q/playlists'" target="_blank">
              <v-icon>slideshow</v-icon>&ensp;&ensp;
              <span>Tutorial</span>
            </v-list-tile>

            <v-list-tile id="in_freeTraining_help" @click="$refs.PFreeTraining.openDialog()">
              <v-icon>contact_mail</v-icon>&ensp;&ensp;
              <span>Solicitar demonstração</span>       
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-toolbar-items>
        <p-stop-watch ref="stopWatch"></p-stop-watch>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-tooltip max-width="50vw" bottom v-if="checkNotificationSupported" v-model="showNotification">
          <template v-slot:activator="{ on }">
            <v-btn class="btn-notification" @click="openNotifications" slot="activator" flat style="padding: 0">
              <v-badge small :color="notificationsEnabled ? '#039BE5' : '#888888'" overlap>
                <template v-if="notificationQuantity > 0" v-slot:badge>
                  <span> {{ notificationQuantity }} </span>
                </template>
                <v-icon :color="notificationsEnabled ? '#64DD17' : '#888888'">notifications</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <p-card-notification ref="PCardNotification" v-if="released" v-show="showNotification" @notificationBadge="updateNotificationBadge" @inviteBadge="updateInviteBadge" @closeNotifications="showNotification = false"></p-card-notification>
        </v-tooltip>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-menu origin="center center" transition="scale-transition" style>
          <v-btn flat slot="activator">
            <v-badge left bottom class='badge-company' :value="companyInvites > 0" color="#4b9ea9">
              <template v-slot:badge>
                <span>{{companyInvites}}</span>
              </template>
              <div v-if="!this.$auth.user().photo_path">
                <span>{{this.$auth.user().id_text | formatAbbreviation(10)}}</span>
                <v-icon dark>arrow_drop_down</v-icon>
              </div>
              <img v-else :src="`${basePath}uploads/users/${this.$auth.user().photo_path}`" height="50px" style="border-radius: 50%;">
            </v-badge>
          </v-btn>
          <v-list style="width: 135px;">
            <v-list-tile to="/companies">
              <v-list-tile-title  class="company-menu-title">
                  <span>Empresas</span>
                  <span v-if="companyInvites > 0" class="span-badge">{{companyInvites}}</span>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile to="/user">
              <v-list-tile-title>Editar Perfil</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="logout()">
              <v-list-tile-title>Sair</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <!-- <div class="in-container" :class="{ 'in-max-width': !$vuetify.breakpoint.smAndDown }">       -->
    <div class="in-container">      
      <v-card width="100%">
        <v-card-text style="padding: 0">
          <!-- Função callIn() usada para fazer chamadas para o in de componentes internos como chamar a tela de usuários da emrpesa -->
          <router-view v-if="released" :connection-invites="connectionInvites" @callIn="callIn"/>
        </v-card-text>
      </v-card>

      <div :class="$vuetify.breakpoint.smAndDown ? 'in-buttons-mobile' : 'in-buttons'" :style="!inButtons?$vuetify.breakpoint.smAndDown ? 'top: 10px;' : 'right: -50px':''">
        <v-layout class="in-buttons-p fill-height" :class="$vuetify.breakpoint.smAndDown ? 'justify-center row' : 'justify-start column'">          
          
          <v-badge v-if="$vuetify.breakpoint.smAndDown" color="#ffffff00" style="position: absolute; left: 50%; bottom: -25px; transform: translateX(-50%) rotate(-90deg);" bottom left overlap >
            <template v-slot:badge v-if="!inButtons && stopWatchActive()">
              <v-icon id="in_actionStopWatch_buttons" @click="clickActionBar()" small style="transform: translate(8px, -8px) rotate(90deg);" color="purple">watch_later</v-icon>
            </template>
            <v-btn id="in_action_buttons" @click="clickActionBar()" small icon style="background: #909090;">
              <v-icon v-if="inButtons" color="#fff" small>chevron_right</v-icon>
              <v-icon v-else color="#fff" small>chevron_left</v-icon>
            </v-btn>
          </v-badge>
          <v-btn id="in_action_buttons" v-else @click="clickActionBar()" small icon :style="'position: absolute; top: -11px; background: #909090; transition: 0.5s; '+((!inButtons)?'left: -45px;':'left: -25px;')">
            <v-icon v-if="inButtons" color="#fff" small>chevron_right</v-icon>
            <v-icon v-else color="#fff" small>chevron_left</v-icon>
          </v-btn>

          <v-tooltip max-width="95vw" bottom v-if="checkNotificationSupported  && $vuetify.breakpoint.smAndDown" v-model="showNotification">
            <template v-slot:activator="{ on }">
              <v-btn id="in_notification_buttons" class="btn-notification" @click="openNotifications" slot="activator" small fab color="#00acc2">
                <v-badge small right bottom :color="notificationsEnabled ? '#039BE5' : '#888888'">
                  <template v-if="notificationQuantity > 0" v-slot:badge>
                    <span> {{ notificationQuantity }} </span>
                  </template>
                  <v-icon color="#fff" >notifications</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <p-card-notification ref="PCardNotification" v-if="released" v-show="showNotification" @notificationBadge="updateNotificationBadge" @inviteBadge="updateInviteBadge" @closeNotifications="showNotification = false"></p-card-notification>
            
            <!-- <p-card-notification :loading="notificationLoading" @notificationBadge="updateNotificationBadge" @inviteBadge="updateInviteBadge" @closeNotifications="show = false" v-if="released" :items="notifications" :quantity="notificationQuantity"></p-card-notification> -->
          </v-tooltip>

          <p-chat-launcher id="in_chat_buttons" ref="chat"></p-chat-launcher>
         
          <v-tooltip left>
            <v-btn id="in_userTasks_buttons" small color="#00acc2" @click="userTasksClick()" slot="activator" fab>
              <v-icon color="#fff" medium>list</v-icon>
            </v-btn>
            <span>Minhas Tarefas</span>
          </v-tooltip>

          <p-notepad-launcher id="in_notepad_buttons" ref="notepad"></p-notepad-launcher>

          <p-form-list></p-form-list>

          <v-speed-dial direction="bottom" v-if="$vuetify.breakpoint.smAndDown">
            <template v-slot:activator>
              <v-btn id="in_help_buttons" fab small color="primary" >
                <v-icon medium>help_outline</v-icon>
                <v-icon medium>close</v-icon>
              </v-btn>
            </template>

            <v-btn id="in_purechat_help" small color="primary" @click="purechatClick()" fab>
              <v-icon color="#fff" medium>contact_support</v-icon>
            </v-btn>

            <v-btn id="in_youtube_help" small color="primary" :href="'https://www.youtube.com/channel/UChnglEU6grDpO2lHvrmyG0Q/playlists'" target="_blank" fab>
              <v-icon medium>slideshow</v-icon>
            </v-btn>

            <!-- <v-btn small color="#15315C" @click="conpassClick('Ss51uXKTo0FYp')" fab>
              <v-icon medium>preview</v-icon>
            </v-btn> -->
            
            <v-btn id="in_freeTraining_help" small color="primary" @click="$refs.PFreeTraining.openDialog()" fab>
              <v-icon medium>contact_mail</v-icon>
            </v-btn>
          </v-speed-dial>
        </v-layout>
        <div class="row" v-show="inButtons">
          <p-stop-watch id="in_stopWatch_buttons" ref="stopWatch" v-if="$vuetify.breakpoint.smAndDown"></p-stop-watch>
        </div>
      </div>
    </div>
    <v-footer app>
      <v-flex xs12 text-xs-center>
        <span>&copy; {{ new Date().getFullYear() }} - <strong>Illis</strong> - <strong>{{serverTimeFormat}}</strong></span>
        <input v-show="false" type="datetime" id="serverTime" :value="serverTime">
      </v-flex>
    </v-footer>
    <!-- foi usado o emit v-if pois estava feito processamento em todas as telas -->
    <p-company-user-dialog :notBroadcast="true" ref="PCompanyUserDialog"></p-company-user-dialog>
  </v-container>
</template>
<script>
  /* eslint-disable no-undef  */
  import PStopWatch from './../shared/PStopWatch'
  import PUserTasks from './../shared/PUserTasks'
  // Ocultar os recados, bug 773
  // import Message from './../shared/Message'
  import PLoader from './../shared/PLoader'
  import PSnackbar from './../shared/PSnackbar'
  import PSnackbarPlan from './../shared/PSnackbarPlan'
  import PDialogPlan from './../shared/PDialogPlan'
  import PSnackbarButton from './../shared/PSnackbarButton'
  // Foi deletado no comit do dia 15/12/2020
  // import PFirstEntrance from './../shared/PFirstEntrance'
  import access from '../../mixin/access'
  import plan from '../../mixin/plan'
  import notification from '../../mixin/notification.js'
  import PChangeLog from '../shared/PChangeLog.vue'
  import PChatLauncher from '../shared/PChatLauncher.vue'
  import PCardNotification from '../shared/PCardNotification'
  import PNotepadLauncher from '../shared/PNotepadLauncher'
  import PDialogWarning from '../shared/PDialogWarning'
  import PDialogBeta from '../shared/PDialogBeta'
  import PFreeTraining from '../shared/PFreeTraining'
  import PCompanyUserDialog from '../shared/PCompanyUserDialog'
  import PConfirmRegister from '../shared/PConfirmRegister'
  import PUpgradesIllis from '../shared/PUpgradesIllis'
  import PFormList from '../shared/PFormList'
  import general from '../../mixin/general'
  import moment from 'moment'
  import localforage from 'localforage'
  import PTaskFather from './../reports/PTaskFather'
  import PUserWelcome from '../shared/PUserWelcome'
  import PInfoPlan from '../shared/PInfoPlan'
  import PRegisterComplement from '../shared/PRegisterComplement'

  export default {
    /* eslint-disable eqeqeq */
    data: function () {
      return {
        reloadPageSocket: false,
        localforageChanges: null,
        changesSubmitted: false,
        lastClickMenu: '/tasks',
        fab: false,
        openConfirmRegister: false,
        dialogReloadVersion: false,
        showProgressBar: false,
        progressBar: 0,
        dialogWarning: false,
        connectionInvites: 0,
        companyInvites: 0,
        userTasks: false,
        setCheckEnabledInterval: '',
        notificationsEnabled: false,
        drawer: !this.$vuetify.breakpoint.smAndDown,
        mini: !this.$vuetify.breakpoint.smAndDown,
        firstEntrance: false,
        openWelcome: false,
        dialogRegisterComplement: false,
        dialogUserWelcome: false,
        companies: '',
        socketRooms: [],
        basePath: process.env.API,
        serverTime: '',
        companyUserDialog: false,
        serverTimeFormat: '',
        startLocalTime: '',
        startServerTime: '',
        loadCompany: false,
        // Verifica quando os accessos e planos já foram buscados no banco, para liberar a lista do menu de acordo com os acessos
        released: false,
        id: -1,
        access: [],
        // Número que aparecerá no badge. Representa a quantidade de notificações não lidas pelo usuário
        notificationQuantity: 0,
        // showNotification para poder abrir o carde de notificação
        showNotification: 0,
        userId: '',
        inButtons: false,
        timeeee: 0,
        timeee: '',
        topBarColor: 'primary'
      }
    },
    mixins: [plan, access, notification, general],
    name: 'App',
    components: {PNotepadLauncher, PFreeTraining, PUserTasks, PDialogWarning, PDialogBeta, PCompanyUserDialog, PLoader, PSnackbarPlan, PSnackbarButton, PSnackbar, PDialogPlan, PStopWatch, PChangeLog, PChatLauncher, PCardNotification, PConfirmRegister, PUpgradesIllis, PTaskFather, PUserWelcome, PInfoPlan, PFormList, PRegisterComplement},
    sockets: {
      // stopWatch (item) {
      // Este evento funciona da seguinte maneira: é disparado quando o usuário é removido de uma empresa ou uma empresa que ele participa é excluída.
      // Ele é responsável por mostrar na tela o alerta para informar o usuário em uma das duas situações:
      // 1 - Ele está logado na empresa da qual ele foi removido
      // 2 - A empresa em que ele está logado foi excluída do sistema.
      deleteSocketCompany (item) {
        // Verifica se o usuário que recebeu o evento está logado na empresa, se sim mostramos o alerta.
        if (item.company_id === this.$auth.user().company_id) {
          this.$store.commit('dialogWarning/change_values', { text: item.text, showDialog: true })
        }
      },
      reloadPage (item) {
        this.$store.commit('dialogWarning/change_values', { text: item.text, showDialog: true })
      },
      // Evento utilizado para atualizar as permissões dos usuários em tempo real no caso de alguém alterar os acessos da empresa.
      changePermissions (item) {
        // Verificamos se o usuário está logado na empresa a qual os acessos foram alterados
        if (this.$auth.user().company_id === item.company_id) {
          item.permissions = JSON.parse(item.permissions)
          this.$store.commit('access/change_value', item)
        }
      },
      // Evento utilizado para buscar as salas que o usuário está e inserir na varivel que guarda as salas do usuário.
      // Socket chamado tbm sempre que entra ou sai de uma sala
      reloadSocketRooms (rooms) {
        console.log('rooms', rooms)
        // so muda as salar quando o tamanho é maior que 1, pois se for menor não muda
        if (Array.isArray(rooms) && rooms.length > 1) this.socketRooms = rooms
      },
      reloadPageSocket () {
        console.log('reloadPageSocket', this.timeeee)
        this.$http.get(`api/current_company_of_user`).then((res) => {
          // caso o id da empresa no front seja diferente do id no banco, recarrega a página
          if (this.$auth.user().company_id != res.body) {
            console.log('reloadPageSocket_ChangeCompany')
            this.$store.commit('dialogWarning/change_values', { text: 'Você fez login em outra empresa. Será necessário recarregar a página.', showDialog: true })
          }
        })
        if (this.reloadPageSocket) {
          let itemText = 'Essa aba ficou inativa por muito tempo, pode ter dados que não foram atualizados, deseja atualizar?'
          // caso o socket pare de funcionar, mostra um modal para o usuário atualizar a página
          this.$store.commit('dialogWarning/change_values', { text: itemText, showDialog: true, btnClose: true })
        }
        console.log(this.timeee, moment().format('DD/MM/YYYY HH:mm'))
      }
    },
    created: function () {
      this.timeee = moment().format('DD/MM/YYYY HH:mm')
      // ServerTime usado para informar o horario de acordo com o horario do servidor
      setInterval(() => {
        if (this.startServerTime !== '') {
          var time = moment(this.startServerTime).add((new Date() - this.startLocalTime), 'milliseconds')
          this.serverTime = time.format('YYYY-MM-DDTHH:mm:ss.ms')
          this.serverTimeFormat = time.format('DD/MM/YYYY HH:mm:ss')
        }
        this.timeeee = this.timeeee + 1
      }, 1000)
      this.changesSubmitted = false
      this.released = false
      //* Quando o usuário faz logout devemos enviar um evento para mostrar o dialog na tela informando em todas as abas que o usuário está logado que ele terá que recarregar a página para continuar utilizando o sistema. Porém pode acotecer, em alguns casos, de a página recarregar sozinha e quando o usuário faz login novamente, o dialog aparece na tela sem necessidade. Por isso, configuramos o "showDialog" do "dialogWarning" sempre para "false" para que ao abrir a página, não corra risco de ele estar aberto.
      this.$store.commit('dialogWarning/change_values', { showDialog: false })
      this.$store.commit('loader/change_dialog', true)
      // reset usado pois quando saia do usuário e logava em outro o vuex continuava com valores do antigo
      this.$store.commit('stopWatch/reset_values')
      this.$http.get('api/open_in').then((res) => {
        // preenche as variaveis do sistema
        let system = (res.body['system'] || [])
        system.forEach(function (config) {
          // Converte a descrição do addManyTasks de string para array/json
          if (config['id_text'] == 'addManyTasks' || config['id_text'] == 'reloadPageSocket') {
            config['description'] = JSON.parse(config['description'])
          }
        })
        this.$store.commit('system/change_values', system)
        // verificações do codigo para ver se é a primeira vez que o usuário entra ou se deve mostrar a tela de digitar o codigo
        let user = this.$auth.user()
        if (user.code !== null) {
          // O code representa  a primeira vez que o usuário entra, se for apenas first significa que é um registro normal, se for FIRSTGUEST significa que é um registro por um convite.
          this.firstEntrance = user.code == 'FIRST' || user.code == 'FIRSTGUEST'
          // verificação pra saber se o usuario acabou de se registrar
          if (this.firstEntrance) {
            // Verifica se o openWelcome está habilitado, pois se não tiver não deve mostrar a tela inicial
            this.openWelcome = system.find(val => val['id_text'] == 'openWelcome')
            this.openWelcome = this.openWelcome ? (this.openWelcome['description'] == 1) : false
            // Se for a primeira vez que o usuário que acabou de se cadastrar sem ser por uma empresa já criada, logo deve abrir a tela com o restante das informações
            if (user.code == 'FIRST') {
              this.dialogRegisterComplement = true
              // caso contrario significa que o usuário entrou por um convite, então deve apenas abrir a tela de boas vindas
            } else if (this.openWelcome) {
              this.dialogUserWelcome = true
            }

            // converte em string pois o campo no banco é string
            let code = String(Math.floor(Math.random() * (999999 - 100000)) + 100000)
            // Sendo o primeiro acesso dele, é gerado o codigo, mas ainda não é enviado para o email
            this.$http.post(`auth/register_code`, {'id': user.id, 'user': user.id_text, 'email': user.email, 'code': code, 'sendEmail': false}).then((res) => { console.log(res) },
              (err) => {
                // insere o code na variavel do usuário
                this.$auth.user()['code'] = code
                this.$store.commit('snackbar/change_values', {text: 'Não foi possível enviar o código, porfavor contate o suporte', color: 'error', dialog: true})
                console.log(err)
              })
          } else {
            // após o segundo acesso ou mais, mostra a tela de confirmação de codigo e envia email com o codigo até o usuario verificar.
            this.openConfirmRegister = true
            // converte em string pois o campo no banco é string
            let code = user.code
            this.$http.post(`auth/register_code`, {'id': user.id, 'user': user.id_text, 'email': user.email, 'code': code, 'sendEmail': true}).then(
              (res) => {
                this.$auth.user()['code'] = code
              },
              (err) => {
                // insere o code na variavel do usuário
                console.log(err)
                this.$store.commit('snackbar/change_values', {text: 'Não foi possível enviar o código, porfavor contate o suporte', color: 'error', dialog: true})
              })
          }
        }
        // Pega a versão que o illis está no navegador do usuário
        let localVersion = document.getElementById('system_version').value
        // Verifica se o usuário ou a empresa está ativa para aparecer o recarregar pagina quando sai da sala socket
        let reloadPageSocket = system.find(val => val['id_text'] == 'reloadPageSocket')
        reloadPageSocket = reloadPageSocket ? reloadPageSocket['description'] : false
        if (reloadPageSocket && reloadPageSocket != {}) this.reloadPageSocket = (reloadPageSocket['users'].includes(this.$auth.user().id) || reloadPageSocket['companies'].includes(this.$auth.user().company_id))
        // pega a versão do sistema que está na tabela
        let systemVersion = system.find(val => val['id_text'] == 'version')
        // verifica se a versão do sistema está atualizada comparando com a do banco
        console.log('localVersion ', localVersion, ' - systemVersion ', systemVersion['description'])
        if (parseInt(localVersion) < parseInt(systemVersion['description'])) {
          // caso não esteja, limpa todos os caches
          caches.keys().then((cacheNames) => {
            console.log('cacheNames', cacheNames)
            // verifica se veio array
            if (Array.isArray(cacheNames)) {
              // deleta todos os caches
              cacheNames.forEach(cacheName => {
                caches.delete(cacheName)
              })
            }
          })
        }
        // Caso o usuário entrou antes de subir as atualizações e não sejá a primeira vez que ele entra mostra as novidades para ele
        if (res.body['upgrades_illis'].length > 0 && !this.firstEntrance) {
          // Se não for a primeira vez ai pede para atualizar para limpar possiveis cookies
          this.$refs.PUpgradesIllis.reloadPage = true
          this.$refs.PUpgradesIllis.items = res.body['upgrades_illis']
          this.$refs.PUpgradesIllis.dialogUpgradesIllis = true
          // caso não tenha atualizações verifica a versão, para sempre mostrar o temos novidades primeiro
        } else {
          // Caso a versão local do usuário seja diferente da do sistema manda msg para o usuário atualizar a página e as versões ficarem iguais
          if (parseInt(localVersion) < parseInt(systemVersion['description'])) {
            this.dialogReloadVersion = true
            this.showProgressBar = true
            this.progressBar = 0
            let intervalProgressBar = setInterval(() => {
              if (this.progressBar === 100) {
                clearInterval(intervalProgressBar)
                this.showProgressBar = false
              }
              this.progressBar = this.progressBar + 10
            }, 1000)
          }
        }

        // armazena o usuário da ultima pessoa logada para ser usado quando está offline
        localStorage.setItem('last_user', `{"id": ${this.$auth.user().id}, "id_text": "${this.$auth.user().id_text}", "email": "${this.$auth.user().email}", "company_id": ${this.$auth.user().company_id}}`)
        // Seta o tempo do servidor
        this.startLocalTime = new Date()
        this.startServerTime = res.body.serverTime
        // stop_watch_active
        let valuesStopWatch = JSON.parse(JSON.stringify(res.body.stop_watch_active))
        // Verifica se tem alguma duração ativa, se tiver starta ela
        if (valuesStopWatch && valuesStopWatch.active) {
          valuesStopWatch.id_text = valuesStopWatch.task_clean.id_text
          this.$store.commit('stopWatch/change_values', valuesStopWatch)
          this.$refs.stopWatch.startTime()
        }
        // get_access_user
        this.access = res.body.get_access_user
        this.access.permissions = JSON.parse(this.access.permissions)
        this.$store.commit('access/change_value', this.access)
        // Armazenta todos os filtros do sistema
        let filter = JSON.parse(res.body.current_company_user.filter || null) || {}
        this.$store.commit('filter/change_values', filter)
        // current_company_user
        let companyUserParams = JSON.parse(res.body.current_company_user.params || null) || {}
        this.$store.commit('companyUserParams/change_values', companyUserParams)
        // Incluir o admin para ser usado nas telas que precisam como dashboard, relatórios
        this.$auth.user()['admin'] = res.body.current_company_user.admin
        // Caso não seja a primeira vez que o usuário entrou na empresa e a útima vez que ele entrou tem amis de um dia, mostra as tarefas do dia
        if (!this.firstEntrance && moment(String(this.startServerTime).split(' ')[0]).isAfter(res.body.current_company_user.last_time, 'day')) {
          this.userTasks = companyUserParams['openDaily']
        }
        // get_notifications
        // Busca a quantidades das notificações do usuário, qutd de convites em aberto
        this.$http.get(`api/get_user_invites`).then((res) => {
          this.companyInvites = res.body['company']
          this.connectionInvites = res.body['connection']
        })
        this.notificationQuantity = res.body.get_notifications
        // get_plan_user
        this.plan = res.body.get_plan_user
        this.plan.accesses = JSON.parse(this.plan.accesses || '{}')
        this.$store.commit('plan/change_value', this.plan)
        // Verifica se é para mostrar a barra lateral pro usuário ou não
        this.inButtons = companyUserParams.hasOwnProperty('actionBar') ? companyUserParams['actionBar'] : false
        // Ocultar os recados, bug 773
        // if (this.$route.name !== 'Messages') {
        //   this.$refs.messages.updateLabels(res.body.message_labels)
        // }
        // <!-- Inicializar o Conpass -->
        var count = 0
        var interval = window.setInterval(() => {
          if (window.Conpass) {
            window.Conpass.init({
              name: this.$auth.user().id_text,
              email: this.$auth.user().email
            })
            window.clearInterval(interval)
            // Caso seja a primeira vez que o usuário entra no sistema, abre o chat do illis
            // colocado dentro do open_in pois de fora ainda não teria montado o chat, dando erro ao tentar abrir
            // O conpass sera aberto pelo propio conpass a primeira vez q o usuário entra
            if (this.firstEntrance) {
              // Abre o conpass para o tutorial guiado
              this.conpassClick('6BrB8zkxb30J')
              // // Abre o chat a primeira vez q o usuário entra
              // this.$refs.chat.openChatIllis()
            }
          }
          if (count >= 50) {
            window.clearInterval(interval)
          }
          count += 1
        }, 500)
        this.$store.commit('loader/change_dialog', false)
        this.released = true
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {
          text: 'Ocorreu um erro ao tentar fazer o login. Favor tentar novamente ou reporte o erro!',
          color: 'error',
          dialog: true
        })
        // caso ocorra algum problema ao logar no open_in, desloga o usuário
        this.logout()
      })
      this.localforageChanges = localforage.createInstance({driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE], name: 'illis-offline', version: 1.0, storeName: 'changes', description: 'guarda as alterações offline para passar pro banco depois'})
      // verifica se foi feito alguma alteração no modo offline se sim salva elas no banco
      this.localforageChanges.iterate((value, key, iterationNumber) => {
        this.$http.post(`api/save_changes`, value).then((res) => {
          this.localforageChanges.removeItem(key)
        }, err => {
          if (err.body.message === 'changesIsNotUser') {
            this.$store.commit('snackbar/change_values', {timeout: 8000, text: 'Existem alterações offline que não são para esse usuário.', color: 'warning', dialog: true})
          } else {
            console.log(err)
            this.$store.commit('snackbar/change_values', {text: 'Ocorreu um erro em uma alteração offline, reporte o erro.', color: 'error', dialog: true})
          }
        })
      }).then(() => {
        this.changesSubmitted = true
        this.$store.commit('snackbar/change_values', {text: 'Alterações offline foram salvas.', color: 'success', dialog: true})
      }).catch((err) => {
        this.changesSubmitted = true
        this.$store.commit('snackbar/change_values', {text: 'Não foi possível salvar suas alterações offline, reporte o erro.', color: 'error', dialog: true})
        console.log(err)
      })
    },
    mounted () {
      setInterval(() => {
        // Atualiza as salas que o usuário está, para garantir que ele não irá sair das salas
        this.$socket.emit('reloadSocketRooms', this.socketRooms)
        // caso o usuário deslogue em alguma outra aba, mostra um modal para o usuário atualizar a página
        if (!this.$auth.token()) {
          let itemText = 'Você não está mais logado no sistema, deseja atualizar?'
          this.$store.commit('dialogWarning/change_values', { text: itemText, showDialog: true, btnClose: true })
        }
      }, 15000)
      this.$socket.emit('joinRoom', {room: `user${this.$auth.user().id}`})
      // === POSTERIORMENTE ESTE INTERVALO SERÁ SUBSTITUIDO POR EVENTOS SOCKET ===
      this.setCheckEnabledInterval = setInterval(() => {
        this.notificationsEnabled = localStorage.getItem('notificationsEnabled') === 'true'
      }, 1000)

      // Verifica onde o usuário está usando para incluir a cor da barra do topo ao entrar
      this.topBarColor = location.href.includes('localhost:8086') ? '#ec766d' : (location.href.includes('app.alfa.illis.com.br') ? '#e0d05e' : 'primary')
    },
    methods: {
      companyManage () {
        let previouesRoute = this.$route.path
        this.$router.push('/company/' + this.$auth.user().company_id)
        if (previouesRoute.includes('compan')) {
          location.reload()
        }
      },
      updateNotificationBadge (data) {
        this.notificationQuantity = data
      },
      updateInviteBadge (data) {
        this.companyInvites = data['company']
        this.connectionInvites = data['connection']
      },
      openConfig (type = 0) {
        this.userConfig = type === 0
      },
      callFunction: function (func) {
        // Quando o usuário troca de tela, zera as salas que ele estava para não vir salas de outras telas
        this.socketRooms = []
        if (func) {
          return func.call()
        }
      },
      openChangelog: function () {
        this.$refs.changelog.dialog = true
      },
      openCompanyUserDialog: function () {
        this.$refs.PCompanyUserDialog.openDialog()
      },
      refreshCompany: function () {
        this.loadCompany = true
        this.$http.get('api/get_accepted_companies').then(res => {
          this.companies = res.body
          this.loadCompany = false
        })
      },
      changeCompany: function (companyId) {
        if (companyId !== this.$auth.user().company_id) {
          this.$http.post('auth/change-company', {'company_id': companyId}).then(res => {
            // volta para a home e da um reload na pagina para atualizar a company
            this.$socket.emit('leaveRoom', {room: `user${this.$auth.user().id}`})
            this.$socket.emit('generalEvent', {
              data: {text: `Você fez login em outra empresa. Será necessário recarregar a página.`},
              notBroadcast: true,
              responseEvent: 'reloadPage',
              room: `user${this.$auth.user().id}`
            })
            this.$router.push({name: 'Home'})
            location.hash = '#/home'
            setTimeout(() => {
              location.reload()
            }, 200)
          })
        }
      },
      logout: function () {
        this.$store.commit('loader/change_dialog', true)
        this.userId = this.$auth.user().id
        this.$auth.logout({
          makeRequest: true
        }).then(res => {
          this.$store.commit('loader/change_dialog', false)
          this.$socket.emit('generalEvent', {
            data: {text: `Você se desconectou do sistema. Será necessário recarregar a página.`},
            notBroadcast: true,
            responseEvent: 'reloadPage',
            room: `user${this.userId}`
          })
          // Utilizado o método findSubscription pois this.subscription estava como null.
          this.findSubscription()
            .then(sub => {
              if (sub !== null) {
                this.subscription = sub
                this.disableSubscription()
              }
            })
        }, err => {
          this.dialogReloadVersion = true
          console.log('err', err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Porfavor, corrija as validações para continuar',
            color: 'warning',
            dialog: true,
            timeout: 6000
          })
        })
      },
      openNotifications () {
        this.showNotification = true
        this.$refs.PCardNotification.notificationLoad()
      },
      purechatClick: function () {
        document.getElementById('purechat-btn').click()
      },
      conpassClick: function (code) {
        if (typeof Conpass !== 'undefined') {
          Conpass.startFlow(code)
        }
      },
      userTasksClick: function () {
        this.userTasks = false
        setTimeout(() => {
          this.userTasks = true
        }, 500)
      },
      stopWatchActive: function () {
        return !!document.getElementById('btnDuration')
      },
      callIn (val) {
        if (val === 'openCompanyUserDialog') {
          this.openCompanyUserDialog()
        }
      },
      clickMenu (route) {
        // Caso o usuário clica no menu novamente verifica se o link é o msm para recarregar a página
        // verifica se é diferente de vazio pois quando não troca de pagina n deve atualiza, exemplo "Convidar usuário"
        if (route === this.lastClickMenu && route !== '') this.$router.go()
        if (route !== '') {
          this.lastClickMenu = route
        }
      },
      clickActionBar () {
        this.inButtons = !this.inButtons
        let params = this.$store.getters[`companyUserParams/values`]
        Object.assign(params, {'actionBar': this.inButtons})
        this.$store.commit('companyUserParams/change_values', params)
        this.$http.post('auth/change-user-params', {'params': JSON.stringify(params)})
      },
      confirmReloadVersion () {
        window.location.href = window.location.href
        window.location.reload('true')
        this.dialogReloadVersion = false
      },
      nextRegisterComplement () {
        this.dialogRegisterComplement = false
        // caso o openWelcome esteja ativo mostra a tela de boas vindas
        this.dialogUserWelcome = this.openWelcome
      }
    },
    computed: {
      items: function () {
        return [
          {header: 'Movimentações'}, {
            icon: this.translate('table.tasks.icon'),
            title: this.translate('table.tasks.title')[1],
            route: 'tasks'
          }, {
            icon: this.translate('table.calendar.icon'),
            title: this.translate('table.calendar.title')[0],
            route: 'calendar'
          }, {
            icon: this.translate('table.files.icon'),
            title: this.translate('table.files.title')[1],
            route: 'files'
          },
          {divider: true},
          {header: 'Cadastros'},
          {
            icon: this.translate('table.companyParticipants.icon'),
            title: 'Convidar Usuários',
            name: 'companyUser'
          }, {
            icon: this.translate('table.teams.icon'),
            title: this.translate('table.teams.title')[1],
            route: 'teams'
          }, {
            icon: this.translate('table.tasktemplates.icon'),
            title: this.translate('table.tasktemplates.title')[1],
            route: 'tasktemplates'
          }, {
            icon: this.translate('table.connections.icon'),
            title: this.translate('table.connections.title')[1],
            notify: this.connectionInvites,
            // variavel que serve pra notiicar ao usuario atraves da barra de menu sobre quantos convites de conexoes pendentes existem
            route: 'connections'
          }, {
            icon: this.translate('table.accesses.icon'),
            title: this.translate('table.accesses.title')[1],
            route: 'accesses'
          // Ocultar os recados, bug 773
          // }, {
          //   icon: this.translate('table.messages.icon'),
          //   title: this.translate('table.messages.title')[1],
          //   route: 'messages'
          },
          {divider: true},
          {header: 'Análises'},
          {
            icon: this.translate('table.dashboard.icon'),
            title: this.translate('table.dashboard.title')[0],
            route: 'dashboard_movement'
          }, {
            icon: this.translate('table.reports.icon'),
            title: this.translate('table.reports.title')[1],
            route: 'report'
          }
          // {divider: true},
          // {header: 'Configurações'},
          // {
          //   icon: this.translate('table.changelog.icon'),
          //   title: this.translate('table.changelog.title')[1],
          //   action: this.openChangelog
          // }
        ]
      },
      destroyed () {
        this.$socket.emit('leaveRoom', {room: `user${this.$auth.user().user_id}`})
        clearInterval(this.setCheckEnabledInterval)
      }
    }
  }
</script>

<style>
  /* insere a font arial como default no preview do documento personalizado */
  .page {
    font-family: arial !important;
  }
  /* Coloca as informações de paginação centralizadas para que o adicionar não fique por cima */
  .v-datatable__actions,.v-datatable__actions__select {
    justify-content: center !important;
  }
  .v-datatable__actions__range-controls {
    margin-right: 45px !important;
  }
  /* menu_content Usado no v-menu quando tem algumas opções que o layout ficava um pouco cortado */
  .menu_content {
    padding: 0 10px 10px 10px;
  }
  /* Para ajudstar o icone do play do botão de beta */
  .beta .v-chip__content {
    padding-right: 0px !important;
  }
  /* diminui o tamanho do select solo que estão com a classe small-size-illis*/
  .small-size-illis.v-text-field.v-text-field--solo .v-input__control{
    min-height: 36px;
  }
  /* diminui o tamanho do select outline que estão com a classe small-size-illis*/
  .small-size-illis.v-text-field.v-text-field--outline .v-input__control .v-input__slot{
    min-height: 36px;
  }
  .small-size-illis.v-text-field.v-text-field--outline .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon {
    padding-bottom: 15px;
  }
  /* Diminui a caixa de texto */
  .small-checkbox .v-label {
    font-size: 12px;
  }
  .small-checkbox .v-icon {
    font-size: 15px;
  }
  .small-checkbox .v-input--selection-controls__input {
    margin-right: 0px;
  }
  /* diminui o tamanho da lista e tira os paddings laterais */
 .small-list .v-list__tile {
    height: 40px;
    padding-left: 0px;
    padding-right: 0px;
  }

  /* diminui o tamanhao da table   */
  .small-data-table .v-table tr {
    height: 40px !important;
  }
  .small-data-table .v-table thead .v-datatable__progress {
    height: 0.3px !important;
  }

  /* ajusta o badge da dashboard personalizada  */
  .dash_badge .v-badge__badge {
    margin-bottom: 4px;
    margin-left: 5px;
  }
  /* alteração do tamanho da fonte na dashboard personalizada */
  .apexcharts-text, .apexcharts-legend-text, .apexcharts-bar-area {
    font-size: 15px !important;
  }

  /* Texto das tarefas */
  .task-text {
    color: #02444d;
  }
  /* Quebra de linha em palavra */
  .break-word {
    word-break: break-word;
  }
  /* Quebra de linha em caracter */
  .break-all {
    word-break: break-all;
  }
  /* As frases terão apenas uma linha */
  .one-line {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  /* As frases terão apenas 2 linha */
  .two-line {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  /* As frases terão apenas 3 linha */
  .three-line {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  /* Diminui o tamanho dos footers */
  .v-datatable__actions__select {
    height: 40px;
  }
  /* fc-timegrid-col serve para aumentar o tamanho dos eventos na semana */
  .fc-timegrid-col {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  /* fc-daygrid-day serve para aumentar o tamanho dos eventos no mes */
  .fc-daygrid-day {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  /* fc-col-header-cell os titulos não ficarem fora das caixas no mobile */
  .fc-col-header-cell {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  .hr-menu-divider{
    border: none;
    border-bottom: 1px solid hsla(0,0%,100%,.12);
  }

  .div-menu-subheader{
    font-size: 13px;
    height: 40px;
    color: hsla(0,0%,100%,.7);
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  .user-avatar-menu{
    display: flex;
  }

  .user-avatar-item{
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    padding: 2px 4px;
    font-size: 1.5em;
    font-weight: bold;
    background: #fff;
    color: #00acc2;
  }

  .mobile-toolbar-items{
    width: 100%;
    display: flex;
    justify-content: space-between;  
  }

  .avatar-click{
    cursor: pointer;
  }

  .navigattion-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .app-company-title{
    padding: 8px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .avatar,
  .app-company-title .text{
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fff;
  }

  .avatar img{
    width: 46px;
    height: 46px;
    border-radius: 50%;
  }

  .companies_list{
    max-height: 400px;
  }

  .app-company-title .text{
    font-size: 30px;
    font-weight: bold;
    color: #00acc1;
  }

  .in-container {
    display: flex;
    width: 100%;
  }

  .in-container .in-buttons,
  .in-container .in-buttons-mobile {
    position: fixed;
    width: 42px;
    right: 0;
    z-index: 4;
    height: calc(100% - 300px);
    background: #546E7A99;
    transition: 0.5s;
    border-radius: 10px;
  }

  .in-container .in-buttons-mobile {
    width: 90%;
    margin: 0 auto;
    top: 60px;
    left: 0;
    height: auto;
    display: flex;
    flex-direction: column;
  }
  
  .in-buttons-p {
    display: flex;
    align-items: center;
    justify-content: start;
  }

  .v-tooltip__content {
    opacity: 1 !important;
  }

  tr {
    padding: 0 !important;
    margin: 0 !important;
    min-height: 0 !important;
  }

  td, th {
    padding: 0 10px !important;
    margin: 0 !important;
    min-height: 0 !important;
  }

  .container{
    padding: 10px !important;
    margin: 0 !important;
  }

  v-card .container{
    padding: 0 !important;
  }
  #brand {
    margin: 0;
    height: 100%;
    font-size: 20px;
    text-transform: capitalize;
  }

  #upgrade {
    margin: 0;
    width: 100%;
    padding: 20px;
    color: #ffbb25 !important;
    text-transform: capitalize;
    border-radius: 0;
  }
  /*--------- Início botão de treinamento no topo ---------*/
  .avatar_training_button{
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 40px;
    margin-top: 4px !important;
    border-radius: 10px;
    padding: 10px;
    background: #017d8d;
    transition: 0.5s;
    box-shadow: 4px 4px 8px #dddddd95;
    position: absolute;
    left: 50%;
    transform: translateX(-60%);
  }

  .avatar_training_button:hover:hover{
    background: #4a8b94;
    transition: 0.5s;
  }

  .avatar_training_button span{
    display: inline-block;
    margin-left: 6px;
  }
  /*--------- Fim botão de treinamento no topo ---------*/

/* ----------Inicio Tela de gerenciamento--------------- */
  .p-gradient {
    background-image: linear-gradient(to bottom right, #56bd89 0%, #3d92cf 100%); /* the gradient */
    padding: 5px;
  }

  .p-white {
    min-height: 52px !important;
    height: 100%;
    background: white; /* if not set cell would also be transparent and show the gradient */
    outline: 3px solid white;
    min-height: 50px;
  }

  .p-label {
    font-size: 10pt;
    color: #96989A;
  }

  .p-content {
    font-size: 16pt;
    font-weight: 600;
  }

  tr td:last-child {
    min-width: 130px;
  }

  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    /* Colocado o z-index como 3 pois acima disso a barra de ações laterais está atrapalhando no momento de clicar em botões que possuem contato com ela */
    z-index: 3;
  }
/* ----------Fim Tela de gerenciamento--------------- */

/* Retirando borda inferior */
 .tab-buttons .tab-buttons-switch .v-input__control .v-input__slot,
 .tab-buttons .tab-buttons-switch-left .v-input__control .v-input__slot{
  margin-bottom: 0;
}

/* Alinhamento do botão de Exibição de subtarefas da tela de tarefas a direita */
 .tab-buttons .tab-buttons-switch .v-input__control .v-input__slot{
  justify-content: flex-end !important;
}

/* Altera o cursor do mouse para mãozinha no status da tarefa */
.task-status-chip .v-chip__content{
  cursor: pointer !important;
}

.company-menu-title{
  position: relative;
}

.company-menu-title .span-badge{
  position: absolute;
  color: white;
  display: inline-block;
  background: #4b9ea9;
  padding: 0 6px;
  border-radius: 50%;
  top: 0px;
  right: 5px;
}

.badge-company .v-badge__badge{
  margin-bottom: 12px!important;
  margin-left: 5px!important;
}

@media screen and (max-width: 650px){
  td, td button {
    font-size: 11px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/In.vue